import React from "react"
import PropTypes from "prop-types"
import { StyledCard } from "./styles"
import CloseIcon from "../close-icon"
import Grid from "../grid"
import { useState } from "react"

const Card = ({ children, ...rest }) => {
  const dismissalPersisted = () => {
    return localStorage.getItem(rest.dismissableKey) === "true"
  }

  const [cardHidden, setCardHidden] = useState(dismissalPersisted())

  const persistDismissal = () => {
    localStorage.setItem(rest.dismissableKey, "true")
  }

  const dismissCard = () => {
    setCardHidden(true)

    if (rest.dismissableKey) persistDismissal()
  }

  const renderCloseIcon = () => {
    return (
      <CloseIcon
        size="large"
        onClick={dismissCard}
        variant="secondary"
        style={{ position: "absolute", right: "1rem", top: "1rem" }}
      />
    )
  }

  return (
    <StyledCard {...rest} hidden={cardHidden}>
      {rest.dismissable && renderCloseIcon()}
      {children}
    </StyledCard>
  )
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white", "danger", "transparent", "warning"]),
  paddingless: PropTypes.bool,
  fixed: PropTypes.bool,
  gridArea: PropTypes.string,
  image: PropTypes.string,
  roundedOnMobile: PropTypes.bool,
  paddinglessOnMobile: PropTypes.bool,
  dismissable: PropTypes.bool,
  dismissableKey: PropTypes.string,
  useAlternativeVariant: PropTypes.bool
}

Card.defaultProps = {
  variant: "default",
  paddingless: false,
  fixed: false,
  gridArea: undefined,
  image: undefined,
  roundedOnMobile: true,
  paddinglessOnMobile: false,
  dismissable: false,
  dismissableKey: undefined,
  useAlternativeVariant: false
}

export default Card
